import { RootState } from '../../app/storeTypes';

const loanPurposeSliceCheck = (state: RootState) => {
    if (!state.loanPurpose) {
        throw new Error('Loan Purpose slice not added to store');
    }

    return state.loanPurpose;
};

export const selectLoanPurposeAEM = (state: RootState) => {
    const { content } = loanPurposeSliceCheck(state);

    return content;
};

export const selectLoanPurposes = (state: RootState) => {
    const { loanPurposeData } = loanPurposeSliceCheck(state);

    return loanPurposeData.loanPurposes;
};

export const selectLoanPurposeIds = (state: RootState) => {
    const { selectedLoanPurposeIds } = loanPurposeSliceCheck(state);

    return selectedLoanPurposeIds;
};

export const selectUpdateLoanPurposeRequest = (state: RootState) => {
    const { updateLoanPurposeRequest } = loanPurposeSliceCheck(state);

    return updateLoanPurposeRequest;
};

export const selectGetLoanPurposeUrl = (state: RootState) => {
    const { apiEndpoints } = loanPurposeSliceCheck(state);

    return apiEndpoints.getLoanPurposeApiUrl;
};

export const selectUpdateLoanPurposeUrl = (state: RootState) => {
    const { apiEndpoints } = loanPurposeSliceCheck(state);

    return apiEndpoints.updateLoanPurposeApiUrl;
};

export const selectGetLoanPurposeApiStatus = (state: RootState) => {
    const { getLoanPurposeApiStatus } = loanPurposeSliceCheck(state);

    return getLoanPurposeApiStatus;
};
